import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { Button } from 'user/components';
import { userRoles } from 'util/appConstants';
import { useActions } from 'hooks/useActions';
import { useAppContext } from 'hooks/useContext';
import { useIsScrolled } from 'hooks/useIsScrolled';
import {
  HeaderWrapper,
  HeaderContainer,
  Logo,
  NavigationContainer,
  Link,
  MenuIcon,
  LinkContainer,
  ProfileAvatar,
  ProfileAvatarContainer,
  A,
} from './styles';
import FlagDropdown from 'user/components/FlagDropdown';
import * as strings from './strings';
import * as authActions from 'global/actions/authActions';
import Path from 'routes/Path';

const communityRoutes = ['/challenges', '/exercises', '/freecode', '/profile', '/courses'];

export default function HeaderCommunity() {
  const [isOpened, setIsOpened] = useState(false);
  const [headerLinks, setHeaderLinks] = useState(strings.FRONT_LINKS);
  const isScrolled = useIsScrolled();
  const history = useHistory();

  const pathname = window.location.pathname;

  const {
    userRole,
    token,
    isCommunityUser,
    isTicketAuth,
    user: { avatar },
  } = useSelector((state) => state.auth);
  const { logout } = useActions(authActions);

  const isCommunity = () => communityRoutes.some((path) => pathname.includes(path));

  useEffect(() => {
    if (userRole && userRole !== userRoles.CANDIDATE) {
      setHeaderLinks([...strings.FRONT_LINKS, ...strings.ADMIN_LINKS()]);
    } else {
      setHeaderLinks(strings.FRONT_LINKS);
    }
  }, [userRole]);

  const LOGIN_BUTTONS = token ? strings.LOGGED_IN_BUTTONS(logout) : strings.NOT_LOGGED_IN_BUTTONS;

  const BUTTONS =
    pathname === '/company'
      ? [...strings.FOR_DEV_BUTTONS, ...LOGIN_BUTTONS]
      : [...strings.BASE_BUTTONS, ...LOGIN_BUTTONS];

  const { language, setLanguage } = useAppContext();

  // Automatically closes menu if pathname or language changes (only happens on smaller resolutions)
  useEffect(() => {
    setIsOpened(false);
  }, [pathname, language]);

  const redirectUser = () => {
    if (isTicketAuth) history.push('/tickets');
    else history.push('/');
  };

  return (
    <HeaderWrapper isScrolled={isScrolled} isOpened={isOpened}>
      <HeaderContainer>
        <Logo isScrolled={isScrolled} isOpened={isOpened} onClick={() => redirectUser()} />
        <MenuIcon onClick={() => setIsOpened(!isOpened)} />
        <NavigationContainer isOpened={isOpened}>
          <LinkContainer>
            {headerLinks.map((link) => {
              return link.extTo ? (
                <A key={`${link[language].replace(' ', '-').toLowerCase()}-${link.extTo}`} textLink href={link.extTo}>
                  {link[language]}
                </A>
              ) : (
                <Link key={`${link[language].replace(' ', '-').toLowerCase()}-${link.to}`} to={link.to}>
                  {link[language]}
                </Link>
              );
            })}
            {BUTTONS.map((button) => {
              const btn = (
                <Button
                  primary={button.style === 'primary'}
                  secondary={button.style === 'secondary'}
                  isMenu
                  isScrolled={isScrolled}
                  onClick={button.func}
                  key={button.func ? button[language].toLowerCase() : undefined}
                >
                  {button[language]}
                </Button>
              );

              if (button.func) {
                return btn;
              }

              return button.externalLink ? (
                <A key={`${button[language].replace(' ', '-').toLowerCase()}-${button.to}`} href={button.to}>
                  {btn}
                </A>
              ) : (
                <Link key={`${button[language].replace(' ', '-').toLowerCase()}-${button.to}`} to={button.to}>
                  {btn}
                </Link>
              );
            })}
          </LinkContainer>
          {isCommunityUser && (
            <Link to={Path.profilePage}>
              <ProfileAvatarContainer isScrolled={isScrolled}>
                {/* <ProfileExperience experience={experiencePercent} /> */}
                <ProfileAvatar image={avatar} />
                {/* <ProfileExperienceText>
                  {experiencePercent}%
                </ProfileExperienceText> */}
              </ProfileAvatarContainer>
            </Link>
          )}
          {!isCommunity() && <FlagDropdown language={language} setLanguage={setLanguage} />}
        </NavigationContainer>
      </HeaderContainer>
    </HeaderWrapper>
  );
}
